import React from 'react';

export const Complaints = () => (
	<h1>Complaints</h1>
);


// WEBPACK FOOTER //
// ./src/containers/Complaints/Complaints.js